import { Link } from 'react-router-dom';

const primaryLinks = [
  { label: 'Software Services', href: '/software-services' },
  { label: 'AI Revenue Audit', href: '/ai-revenue-audit' },
  { label: 'Insights', href: '/blog' },
] as const;

const trustLinks = [
  { label: 'Docs', href: '/docs/concierge-embed' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Public Offer', href: '/public-offer-agreement' },
] as const;

export function WebsiteV2Footer() {
  return (
    <footer className="border-t border-slate-200 bg-[#f1eadf]">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:px-8 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.3em] text-slate-500">
            Practical AI systems for revenue and workflow execution.
          </p>
          <p className="mt-4 max-w-md text-sm leading-7 text-slate-700">
            Dopomogai helps teams decide what to install first, then implements governed systems
            that reduce manual drag and improve execution quality.
          </p>
          <p className="mt-4 text-sm leading-7 text-slate-600">
            The wedge is revenue-first. Delivery and enablement expand only after the business case
            is visible.
          </p>
        </div>

        <div>
          <p className="text-sm font-black uppercase tracking-[0.22em] text-slate-700">Primary Paths</p>
          <div className="mt-4 flex flex-col gap-3">
            {primaryLinks.map((item) => (
              <Link key={item.href} to={item.href} className="text-sm font-semibold text-slate-700 hover:text-slate-950">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-sm font-black uppercase tracking-[0.22em] text-slate-700">Trust</p>
          <div className="mt-4 flex flex-col gap-3">
            {trustLinks.map((item) => (
              <Link key={item.href} to={item.href} className="text-sm font-semibold text-slate-700 hover:text-slate-950">
                {item.label}
              </Link>
            ))}
          </div>
          <p className="mt-5 text-xs leading-6 text-slate-500">
            Impact Parity remains part of the broader Dopomogai story, but this shell keeps the
            public experience focused and commercially clear.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default WebsiteV2Footer;
